export const Loading = () => <div class="loading" />;
